import React from 'react';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NOT_FOUND_LINKS } from '../../config/constants';

import '../NotFound/style.scss';

const Forbidden = () => {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <Container className="Forbidden">
      <div className="row Forbidden__row">
        <div className="col-12 col-md-6 Forbidden__text">
          <h1>{t('general.forbidden')}</h1>
          <h3>{t('general.forbidden_description')}</h3>
          <div className="Forbidden__buttons">
            <Button href={`/${currentLanguage}/${NOT_FOUND_LINKS.contact}`}>{t('general.to_contact')}</Button>

            <Button className="Forbidden__buttons__noborder" href={`/${currentLanguage}/${NOT_FOUND_LINKS.faq}`}>
              {t('general.to_faq')}
              <i className="icon icon-arrow-right" />
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="Forbidden__image" />
        </div>
      </div>
    </Container>
  );
};

export default Forbidden;
